<app-grid>
  <app-cell mobile="0:12" [laptop]="paragraphs.paragraphsLayout === ParagraphsLayoutEnum.None ? '3:9' : '0:12'">

    <div class="paragraphs"
      [class.single-column]="paragraphs.paragraphsLayout === ParagraphsLayoutEnum.None"
      [class.double-column]="paragraphs.paragraphsLayout === ParagraphsLayoutEnum.DoubleColumn"
      [class.triple-column]="paragraphs.paragraphsLayout === ParagraphsLayoutEnum.TripleColumn"
      [class.grey-background]="paragraphs.showGrayBack"
      >
      @for (paragraph of paragraphs!.paragraphs!; track paragraph) {
        <div class="paragraph-item">
          @if (paragraph.subtitle) {
            <h3
              class="subheading serif"
              >
              {{ paragraph.subtitle }}
            </h3>
          }
          <h2 class="big">
            {{ paragraph.title }}
          </h2>
          <div class="paragraph"
            [innerHTML]="paragraph.paragraph | safe:'html'"
          ></div>
          @if (paragraph.buttons) {
            <div class="buttons">
              @for (button of paragraph.buttons; track button) {
                <div>
                  @if (button.link.link) {
                    <app-button
                      [type]="button.link.link ? 'link' : 'button' "
                      [cmsTheme]="button.type"
                      [cmsIcon]="button.icon ? button.icon : undefined"
                                    [layout]="
                                        (button.icon && button.link.label === ' ') ? 'icon-only'
                                        : (button.icon && button.link.label) ? 'icon-label'
                                        : 'label-only'
                                    "
                      [cmsTarget]="button.link.target"
                      [href]="button.link.link"
                      >
                      {{ button.link.label }}
                    </app-button>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </app-cell>
</app-grid>
